<div [class]='panelClass' *ngIf='data' class='d-flex flex-row'>
  <span data-qa='notification-message'>
    {{data.message?.message}}
  </span>
</div>
